import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-home-one',
  templateUrl: './home-one.component.html',
  styleUrls: ['./home-one.component.scss']
})
export class HomeOneComponent implements OnInit {

  contactForm: FormGroup;
  submitted: boolean;
  sliderArr: any = [
    {
      id: 1,
      image: 'assets/img/banner/2.png',
      subTitle: 'German Technology With Indian Brain',
      mainTitle: 'We Build Machinery For Denim Fabrics.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, se eiumod tempor incididunt ut labore et dolore',
      btn1Text: 'DISCOVER MORE',
      btn1Link: '/about-us',
      btn2Text: 'PLAY VIDEO',
      btn2Link: 'https://www.youtube.com/embed/NUooTKtmgz8'
    },
    {
      id: 2,
      image: 'assets/img/banner/1.png',
      subTitle: 'German Technology With Indian Brain',
      mainTitle: 'We Build Machinery For Terry Towel Fabrics.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, se eiumod tempor incididunt ut labore et dolore',
      btn1Text: 'DISCOVER MORE',
      btn1Link: '/about-us',
      btn2Text: 'PLAY VIDEO',
      btn2Link: 'https://www.youtube.com/embed/NUooTKtmgz8'
    },
    {
      id: 3,
      image: 'assets/img/banner/2.png',
      subTitle: 'German Technology With Indian Brain',
      mainTitle: 'We Build Machinery For Suiting Fabrics.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, se eiumod tempor incididunt ut labore et dolore',
      btn1Text: 'DISCOVER MORE',
      btn1Link: '/about-us',
      btn2Text: 'PLAY VIDEO',
      btn2Link: 'https://www.youtube.com/embed/NUooTKtmgz8'
    },
    {
      id: 4,
      image: 'assets/img/banner/1.png',
      subTitle: 'German Technology With Indian Brain',
      mainTitle: 'We Build Machinery For Shirting Fabrics.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, se eiumod tempor incididunt ut labore et dolore',
      btn1Text: 'DISCOVER MORE',
      btn1Link: '/about-us',
      btn2Text: 'PLAY VIDEO',
      btn2Link: 'https://www.youtube.com/embed/NUooTKtmgz8'
    },
    {
      id: 5,
      image: 'assets/img/banner/2.png',
      subTitle: 'German Technology With Indian Brain',
      mainTitle: 'We Build Machinery For Sheeting Fabrics.',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, se eiumod tempor incididunt ut labore et dolore',
      btn1Text: 'DISCOVER MORE',
      btn1Link: '/about-us',
      btn2Text: 'PLAY VIDEO',
      btn2Link: 'https://www.youtube.com/embed/NUooTKtmgz8'
    }
  ];

  satisfactionArr: any = [
    {
      id: 1,
      image: 'assets/img/icon/21.png',
      title: 'Our Team is our',
      mainTitle: 'Strengths',
      description: 'We have a team of internationally acclaimed quality professionals, who inspect the entire manufacturing process & test finished products to ensure global quality. We are able to deliver our products at the customer venue within the stipulated time frame.'
    },
    {
      id: 2,
      image: 'assets/img/icon/21.png',
      title: 'Production Capability',
      mainTitle: 'Infrastructure',
      description: 'The credit for our phenomenal growth in such a short time goes to our sound infrastructure that is equipped with state-of-the-art production facility. We possess a well equipped production unit backed by hi-tech machines and sophisticated technology.'
    },
    {
      id: 3,
      image: 'assets/img/icon/21.png',
      title: 'One Stop Solution',
      mainTitle: 'Product Range',
      description: 'We have carved a niche par excellence in the market through consistently providing world class Textiles Machineries.'
    },
    {
      id: 4,
      image: 'assets/img/icon/21.png',
      title: 'ISO 9001- 2015',
      mainTitle: 'Quality',
      description: 'Our team is committed for effective compliance with it`s Quality Management Systems (ISO 9001- 2000 ).Our aim is to provide world class quality products and services to meet or surpass customer'
    }
  ];

  reviewArr: any = [
      {
        id: 1,
        image: 'assets/img/customer/1.png',
        name: 'FM Denim Co. Ltd',
        rating: 4.5,
        review: 'We FM Denim hereby acknowledge that Prism Textile Machinery Pvt. Ltd. has supplied us their Ring Frame Machine and Two Top-Combers machines. The machines commissioned and functioning fine. Both the machines are giving very good performance, We FM Denim are satisfied with the machines quality and service support by Prism Textile Machinery Pvt. Ltd. We wish Prism Textile all the very best in their future endeavors.'
      },
      {
        id: 2,
        image: 'assets/img/customer/1.png',
        name: 'Arthanari Loom Centre',
        rating: 4,
        review: 'We entrusted the job of Renovation and Overhauling of our Sucker Muller Sizing Machine to you, the PRISM TEXTILE MACHINERY PVT. LTD., Ahmedabad. You took total responsibility of replacement of old DC Drives, DC Motors, Gear Boxes, PLC etc with latest LENZE AC Drives, AC Motors, Gear Boxes, Siemens PLC, complete compact Panel Board, Touch Screen operator Display etc.'
      },
      {
        id: 3,
        image: 'assets/img/customer/1.png',
        name: 'Bhaskar Industries PVT. LTD.',
        rating: 5,
        review: 'We had ordered three nos. New Long Chain Beamer Machine - Ø1000 x 1800 DBF shaft end type beam and One Ball Warping Machine with 560 Ends Creel to M/s. Prism Textile Machinery, Ahmedabad, India.Prism had supply the machine as per our order. The installation done within time and successfully commissioning is done, We appreciate Prism for satisfactory performance of LCB Machine and Ball Warping Machine.'
      }
  ];

  ourClientsArr: any = [
    {
      id: 1,
      image: 'assets/img/clients/client01.jpg'
    },
    {
      id: 2,
      image: 'assets/img/clients/client02.jpg'
    },
    {
      id: 3,
      image: 'assets/img/clients/client03.jpg'
    },
    {
      id: 4,
      image: 'assets/img/clients/client04.jpg'
    },
    {
      id: 5,
      image: 'assets/img/clients/client05.jpg'
    },
    {
      id: 6,
      image: 'assets/img/clients/client06.jpg'
    },
    {
      id: 7,
      image: 'assets/img/clients/client07.jpg'
    },
    {
      id: 8,
      image: 'assets/img/clients/client08.jpg'
    },
    {
      id: 9,
      image: 'assets/img/clients/client09.jpg'
    },
    {
      id: 10,
      image: 'assets/img/clients/client10.jpg'
    },
    {
      id: 11,
      image: 'assets/img/clients/client11.jpg'
    },
    {
      id: 12,
      image: 'assets/img/clients/client12.jpg'
    },
    {
      id: 13,
      image: 'assets/img/clients/client13.jpg'
    },
    {
      id: 14,
      image: 'assets/img/clients/client14.jpg'
    },
    {
      id: 15,
      image: 'assets/img/clients/client15.jpg'
    },
    {
      id: 16,
      image: 'assets/img/clients/client16.jpg'
    },
    {
      id: 17,
      image: 'assets/img/clients/client17.jpg'
    },
    {
      id: 18,
      image: 'assets/img/clients/client18.jpg'
    },
    {
      id: 19,
      image: 'assets/img/clients/client19.jpg'
    },
    {
      id: 20,
      image: 'assets/img/clients/client20.jpg'
    },
    {
      id: 21,
      image: 'assets/img/clients/client21.jpg'
    },
    {
      id: 22,
      image: 'assets/img/clients/client22.jpg'
    },
    {
      id: 23,
      image: 'assets/img/clients/client23.jpg'
    },
    {
      id: 24,
      image: 'assets/img/clients/client24.jpg'
    },
    {
      id: 25,
      image: 'assets/img/clients/client25.jpg'
    },
    {
      id: 26,
      image: 'assets/img/clients/client26.jpg'
    },
    {
      id: 27,
      image: 'assets/img/clients/client27.jpg'
    },
    {
      id: 28,
      image: 'assets/img/clients/client28.jpg'
    },
    {
      id: 29,
      image: 'assets/img/clients/client29.jpg'
    },
    {
      id: 30,
      image: 'assets/img/clients/client30.jpg'
    },
    {
      id: 31,
      image: 'assets/img/clients/client31.jpg'
    },
    {
      id: 32,
      image: 'assets/img/clients/client32.jpg'
    },
    {
      id: 33,
      image: 'assets/img/clients/client33.jpg'
    },
    {
      id: 34,
      image: 'assets/img/clients/client34.jpg'
    },
    {
      id: 35,
      image: 'assets/img/clients/client35.jpg'
    },
    {
      id: 36,
      image: 'assets/img/clients/client36.jpg'
    },
    {
      id: 37,
      image: 'assets/img/clients/client37.jpg'
    },
    {
      id: 38,
      image: 'assets/img/clients/client38.jpg'
    },
    {
      id: 39,
      image: 'assets/img/clients/client39.jpg'
    },
    {
      id: 40,
      image: 'assets/img/clients/client40.jpg'
    }
  ];

  constructor(private fb: FormBuilder,) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      name: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+$")]],
      email: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
      phone: ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      message: ["", Validators.required],
    });
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }
    return true;
  }

  get con(): { [key: string]: AbstractControl } {
    return this.contactForm.controls;
  }
  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }
    const data = {
      name: this.contactForm?.value?.name,
      email: this.contactForm?.value?.email,
      phone: this.contactForm?.value?.phone,
      message: this.contactForm?.value?.message,
    };

    // this.spinner.show();

    // // Make the API call with the constructed data object
    // this.apiCall.contactUsForm(data).subscribe({
    //   next: (response) => {
    //     this.spinner.hide();
    //     if (response.success) {
    //       this.common.showMessage("success", response.message);
    //       this.contactForm.reset();
    //       this.submitted = false;
    //     } else {
    //       this.common.showMessage("error", response.message);
    //     }
    //   },
    //   error: (error: any) => {
    //     this.spinner.hide();
    //     this.common.showMessage("error", error?.message);
    //   },
    // });
  }

}
